import React, { useState } from "react";

import { Button, Modal, TextAreaInput } from "@toddle-edu/ds-web";
import classes from "./AIFeedbackModal.scss";

import { useI18n } from "Hooks";

const AIFeedbackModal = props => {
  const { modalObj, feedbackHandler, viewSource = "", testId } = props;

  const [feedback, setFeedback] = useState("");

  const { t } = useI18n(["common"]);

  const onButtonClick = ({ isFeedbackSkipped }) => {
    feedbackHandler({ feedback, isFeedbackSkipped, status: modalObj.status });
  };

  const onFeedbackSkipButtonClick = () => {
    onButtonClick({ isFeedbackSkipped: true });
  };

  const onFeedbackSendButtonClick = () => {
    onButtonClick({ isFeedbackSkipped: false });
  };

  const modalTitle =
    viewSource === "EVALUATION_RIGHT_PANE"
      ? "classRoom:ai_grading_feedback_dislike_modal_label"
      : "common:ai_response_dialog_text";

  return (
    <Modal
      dsVersion="2.0"
      width="528px"
      height="max-content"
      onClose={onFeedbackSkipButtonClick}
    >
      <Modal.Header title={t(modalTitle)} />
      <Modal.Body>
        <TextAreaInput
          label={t("common:provide_additional_feedback")}
          placeholder={t("common:typeHere")}
          value={feedback}
          onChange={e => setFeedback(e.target.value)}
          maxRows={5}
          testId={`${testId}-feedbackText`}
        />
      </Modal.Body>
      <Modal.Footer>
        <div className={classes.footerContainer}>
          <Button
            dsVersion="2.0"
            variant="neutral"
            type="outlined"
            onClick={onFeedbackSkipButtonClick}
            testId={`${testId}-skip`}
          >
            {t("common:skip")}
          </Button>
          <Button
            dsVersion="2.0"
            variant="progressive"
            onClick={onFeedbackSendButtonClick}
            disabled={!feedback}
            testId={`${testId}-send`}
          >
            {t("common:send")}
          </Button>
        </div>
      </Modal.Footer>
    </Modal>
  );
};

export default AIFeedbackModal;

AIFeedbackModal.defaultProps = {
  testId: "appComponent-aiFeedback-modal",
};
